export default {
    list: {},
    current_lead: {}
}